import React, { useState, useRef, useEffect } from 'react';
import { LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { authService } from '../../../services/apiService';
import './Header.css';

const Header = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const menuRef = useRef(null);

  // Close menu when clicking outside (same pattern as EntityRow)
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    if (menuOpen) document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [menuOpen]);

  const handleLogout = async () => {
    if (isLoggingOut) return;
    setMenuOpen(false);
    setIsLoggingOut(true);
    try {
      await authService.logout();
      // toast.success('Logged out successfully');
    } catch (error) {
      // authService.logout already clears tokens in its finally block,
      // so we just surface any unexpected error and proceed.
      console.error(error);
    } finally {
      setIsLoggingOut(false);
      navigate('/login', { replace: true });
    }
  };

  return (
    <div className="header">
      <div className="header-actions">
        <div className="user-avatar-wrapper" ref={menuRef}>
          <button
            type="button"
            className="user-avatar"
            onClick={() => setMenuOpen((prev) => !prev)}
            aria-label="User menu"
            aria-haspopup="menu"
            aria-expanded={menuOpen}
          >
            JD
          </button>

          {menuOpen && (
            <div className="user-menu-dropdown" role="menu">
              <button
                className="more-menu-item"
                onClick={handleLogout}
                disabled={isLoggingOut}
                role="menuitem"
              >
                <LogOut style={{ width: '0.833vw', height: '0.833vw' }} />
                <span>Logout</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;